import React, { useRef, useEffect, useState } from 'react';
import SignaturePadLibrary from 'signature_pad';
import { Button } from '@crc-evans/ui-components';
import { Trash2, Save } from 'lucide-react';

const DSRSignaturePad = ({ visible, onClose, onSave, title, initialSignature }) => {
  const canvasRef = useRef(null);
  const signaturePadRef = useRef(null);
  const [savedSignature, setSavedSignature] = useState(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [clearedByUser, setClearedByUser] = useState(false);

  useEffect(() => {
    if (visible) {
      setClearedByUser(false);
      setTimeout(() => {
        initializeSignaturePad();
      }, 100);
    }
    // Cleanup
    return () => {
      if (signaturePadRef.current) {
        signaturePadRef.current.off();
        signaturePadRef.current = null;
      }
    };
    // eslint-disable-next-line
  }, [visible]);

  const initializeSignaturePad = () => {
    const canvas = canvasRef.current;
    if (canvas) {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = 150 * ratio;
      canvas.getContext('2d').scale(1, 1);
      signaturePadRef.current = new SignaturePadLibrary(canvas, {
        backgroundColor: 'transparent',
        penColor: 'gray',
        onBegin: () => setIsDrawing(true),
        onEnd: () => setIsDrawing(false),
      });
      // Only load into pad if it's a data URL (e.g. data:image/png;base64,...).
      // After refetch, API may return an S3/http URL; fromDataURL() throws on non-data URLs.
      const isDataUrl = typeof initialSignature === 'string' && initialSignature.startsWith('data:');
      if (isDataUrl) {
        try {
          signaturePadRef.current.fromDataURL(initialSignature);
          setSavedSignature(initialSignature);
        } catch (error) {
          console.error('Failed to load signature:', error);
        }
      }
    }
  };

  const handleSave = () => {
    if (!signaturePadRef.current) {
      return;
    }

    if (signaturePadRef.current.isEmpty()) {
      if (clearedByUser) {
        if (onSave) onSave(null);
      }
      onClose();
      return;
    }

    const base64Image = signaturePadRef.current.toDataURL();
    setSavedSignature(base64Image);
    if (onSave) onSave(base64Image);
    onClose();
  };

  const handleClear = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
    }
    setSavedSignature(null);
    setClearedByUser(true);
  };

  return (
    <div>
      <div style={{ border: '1px solid #ddd', borderRadius: 12, padding: 8, marginBottom: 12 }}>
        <canvas
          ref={canvasRef}
          style={{ width: '100%', height: 150, marginBottom: 8 }}
        />
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
          <Button
            label="Clear"
            variant="tertiary"
            icon={Trash2}
            onClick={handleClear}
            style={{ color: '#EF4444' }}
          />
          <Button
            label="Save"
            variant="primary"
            icon={Save}
            onClick={handleSave}
            style={{ backgroundColor: '#EF4444', borderColor: '#EF4444' }}
          />
        </div>
      </div>
    </div>
  );
};

export default DSRSignaturePad;
